import { render, staticRenderFns } from "./ConfirmDADialog.vue?vue&type=template&id=1ba447a2&scoped=true"
import script from "./ConfirmDADialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDADialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDADialog.vue?vue&type=style&index=0&id=1ba447a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba447a2",
  null
  
)

export default component.exports